import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { situacionPedido } from '../../../../actions';
import moment from 'moment';

class Situacion extends Component {

    static hideMessage() {
        setTimeout(() => {
            if (document.getElementById('alertSituacion')) {
                document.getElementById('alertSituacion').style.display = 'none';
            }
        }, 3000);
    }


constructor(props) {
    super(props);
    this.state = {
      mostrarPanel: false,
      iconAlert: '',
      mensajeAlert: '',
      pedidoVehSituResponse: [],
      mostrarFila: '',
    };
  }


  handleClickSituacion() {
      this.props.loading('block');
      this.props.situacionPedido(this.props.numFichaVta, this.props.numPedidoVeh, this.props.codCia, this.props.codProv)
      .then((data) => {
          if(data.payload.pedidoVehSituResponse != null){
             this.setState({pedidoVehSituResponse: data.payload.pedidoVehSituResponse});
              this.props.loading('');
          }});
          
  }

  componentDidMount(){
    this.handleClickSituacion();
  }
  
  render() {
    return (
      <div>
        <section className='fdv-section tab-pane' id='situacion'>
          <header className='fdv-section-head'>
            <h5 className='fdv-section-title'>Situaciones</h5>
          </header>
          <div className='tableWrapper hidden-xs'>
            <table className='table table-hover'>
              <thead className='table-head'>
                <tr>
                  <th>Orden</th>
                  <th>Código</th>
                  <th>Situaci&oacute;n</th>
                  <th>Fecha</th>
                  <th>Observaci&oacute;n</th>
                  <th>Anulado</th>
                  <th>Usuario</th>
                  <th/>
                </tr>
              </thead>
              {this.state.pedidoVehSituResponse.map((pedidoVehSituResponse, index) => (
                <tbody key={index}>
                  <tr>
                    <td>
                      {pedidoVehSituResponse.numRegPedidoSitu}
                    </td>
                    <td>
                    {pedidoVehSituResponse.codSituPedido}
                    </td>
                    <td>
                    {pedidoVehSituResponse.desSituPedido}
                    </td>
                    <td>
                    {moment(pedidoVehSituResponse.fecSituPedido).format('DD/MM/YYYY')}
                    </td>
                    <td>
                    {pedidoVehSituResponse.obsSituPedido}
                    </td>
                    <td>
                    {pedidoVehSituResponse.indAnulado ? 'ANULADO' : ' '}
                    </td>
                    <td>
                    {pedidoVehSituResponse.coUsuarioCreaReg}
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
      situacion: state.situacion
    };
  }

export default withRouter(
    connect(mapStateToProps,{
        situacionPedido
    })
    (Situacion));


// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/ItemsDetalle/SituacionComponent.js